import { CLEAR_RYFT_ONBOARDING_FIRST_SCREEN, GET_RYFT_ONBOARDING_FIRST_SCREEN } from "../../constants/userDocument/UserDocument"



const initialState = {
    PaymentFirstScreenVisible: null
}
export const GetRyftFirstStepScreenVisibleReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RYFT_ONBOARDING_FIRST_SCREEN:
            console.log("payment session", action.payload)
            return {
                ...state,
                PaymentFirstScreenVisible: action.payload,
            }
        case CLEAR_RYFT_ONBOARDING_FIRST_SCREEN:
            return {
                ...state,
                PaymentFirstScreenVisible: null,
            }
        default:
            return state
    }
}  